import type { SVGProps } from "react";

export default function StopIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M13.9998 2.73608H5.9998C4.23249 2.73608 2.7998 4.16877 2.7998 5.93608V13.9361C2.7998 15.7034 4.23249 17.1361 5.9998 17.1361H13.9998C15.7671 17.1361 17.1998 15.7034 17.1998 13.9361V5.93608C17.1998 4.16877 15.7671 2.73608 13.9998 2.73608Z"
        stroke="#F5A801"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2222 5.93604H7.77778C6.79594 5.93604 6 6.73197 6 7.71382V12.1583C6 13.1401 6.79594 13.936 7.77778 13.936H12.2222C13.204 13.936 14 13.1401 14 12.1583V7.71382C14 6.73197 13.204 5.93604 12.2222 5.93604Z"
        fill="#F5A801"
      />
    </svg>
  );
}
